"use strict"; // jshint ignore:line